import { Skeleton } from '@/components/ui/skeleton';
import { PageWrapper, Container } from '@/components/layout';

/**
 * Skeleton for the Committee Detail page.
 */
export function CommitteeDetailPageSkeleton() {
  return (
    <PageWrapper customContainer={true}>
      {/* Header */}
      <header className="w-full relative overflow-hidden border-b border-border">
        <div
          className="absolute inset-y-0 w-[100vw] left-1/2 -translate-x-1/2 bg-gradient-to-r from-background via-background to-muted/30"
          aria-hidden="true"
        />
        <Container size="xl" padding className="relative z-10">
          <div className="py-4 lg:py-6">
            <Skeleton className="h-6 w-32 mb-3" />
            <Skeleton className="h-9 w-80 mb-2" />
            <Skeleton className="h-5 w-48 mb-4" />
            <div className="flex gap-2">
              <Skeleton className="h-10 w-28" />
              <Skeleton className="h-10 w-24" />
            </div>
          </div>
        </Container>
      </header>

      <Container size="xl" padding>
        {/* Tabs */}
        <div className="border-b border-border mt-4">
          <div className="flex gap-4 -mb-px">
            {['Members', 'Bills', 'Calendar'].map((tab) => (
              <Skeleton key={tab} className="h-10 w-24" />
            ))}
          </div>
        </div>

        {/* Content */}
        <div className="py-6 space-y-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="flex items-center gap-4 p-4 border border-border rounded-lg">
              <Skeleton className="h-12 w-12 rounded-full flex-shrink-0" />
              <div className="flex-1">
                <Skeleton className="h-5 w-40 mb-1" />
                <Skeleton className="h-4 w-32" />
              </div>
              <Skeleton className="h-6 w-20 rounded-full" />
            </div>
          ))}
        </div>
      </Container>
    </PageWrapper>
  );
}
